import React, { useMemo } from "react";
import { BASKETBALL_BLUR_TO_LINE, BASKETBALL_MOBILE_BLUR_TO_LINE } from "../stages/BasketballStage";
import BasketballStage from "../stages/BasketballStage";
import useResponsiveStageAsset from "../../../hooks/useResponsiveStageAsset";
import StagePageLayout from "./StagePageLayout";

export default function BasketballStagePage({ stage, onDone, onSessionPointsChange }) {
  const svgAsset = useResponsiveStageAsset(stage.assets);
  const mobileAsset = stage.assets?.mobile;
  const desktopAsset = stage.assets?.desktop;
  const isMobileSvg =
    Boolean(svgAsset) &&
    ((mobileAsset && mobileAsset !== desktopAsset && svgAsset === mobileAsset) ||
      String(svgAsset).toLowerCase().includes("mobile"));
  const data = useMemo(
    () => ({
      ...stage.data,
      svgAsset: svgAsset || stage.data.svgAsset,
      blurToLineMap: isMobileSvg ? BASKETBALL_MOBILE_BLUR_TO_LINE : BASKETBALL_BLUR_TO_LINE,
    }),
    [stage, svgAsset, isMobileSvg]
  );

  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <BasketballStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
